import PolygonBase from './PolygonBase';
import shapeOctagon from '../assets/icons/shapeOctagon.svg';
import { svgToIcon } from '../utils/svg';

class ShapeOctagon extends PolygonBase {
  calcTextMargin() {
    const { height, width } = this.fabricObject;

    const verticalBound = height / 7;
    const horizontalBound = width / 7;

    return {
      top: verticalBound,
      left: horizontalBound,
      right: horizontalBound,
      bottom: verticalBound,
    };
  }

  static renderIcon() {
    return svgToIcon(shapeOctagon);
  }

  static pathString() {
    return `
      M -0.5 -0.2
      L -0.2 -0.5
      L 0.2 -0.5
      L 0.5 -0.2
      L 0.5 0.2
      L 0.2 0.5
      L -0.2 0.5
      L -0.5 0.2
      Z
    `;
  }
}

export default ShapeOctagon;
